import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileStickyBar from "./MobileStickyBar";
import { ConsentBanner, PreferenceCenter } from "../Consent";
import { useI18n } from "../../i18n/I18nContext";

export default function PublicLayout() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="App flex min-h-screen flex-col">
      <a href="#main" className="skip-link" data-testid="skip-link">{t("common.skipToContent")}</a>
      <Header />
      <main id="main" className="flex-1 pb-16 xl:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyBar />
      <ConsentBanner />
      <PreferenceCenter />
    </div>
  );
}
